import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConfigs } from 'src/app/commons/global-config';

@Injectable({
  providedIn: 'root'
})
export class AppDataService {
  private http: HttpClient;

  constructor(private readonly httpHandler: HttpBackend) {
    this.http = new HttpClient(httpHandler);
  }

  getSettingObject() {
    return GlobalConfigs;
  }
}
